export default "__VITE_ASSET__fa114b5e__"